import React from "react";
import ErrorMessage from "../error-message/ErrorMessage";

const DatePicker = (props) => {

    const { name, handleChange, handleBlur, id, label, isRequired, errorMessage, fieldRegister , minDate} = props;

    const formatDate = (inputdate) => {
        const maxDate = inputdate;
        var date = maxDate.getDate();
        var month = maxDate.getMonth() + 1;
        var year = maxDate.getFullYear();
        if (date < 10) {
            date = '0' + date;
        }
        if (month < 10) {
            month = '0' + month;
        }
        var formattedMaxDate = year + '-' + month + '-' + date;
        return formattedMaxDate;
    }

    return (
        <React.Fragment>
            {label && <label className={isRequired ? "required" : ""}>{label}</label>}
            <input
                id={id}
                data-testid={name}
                name={name}
                type="date"
                className={errorMessage ? "input input--error" : "input"}
                placeholder="PlaceHolder text standard"
                onChange={handleChange}
                onBlur={handleBlur}
                {...fieldRegister}
                max={formatDate(new Date())}
                min={formatDate(new Date(minDate))}
            />
            {errorMessage && <ErrorMessage error={errorMessage} />}
        </React.Fragment>
    )
};

export default DatePicker;